















































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateTransferOrderLineDto from "../../../store/entities/transfer-orders/create-transfer-order-line";
import CreateTransferOrderDto from "../../../store/entities/transfer-orders/create-transfer-order";
import columns from "./create-transfer-order-line-columns";
import moment from "vue-moment";
import CreateTransferOrderLine from "../../../store/entities/transfer-orders/create-transfer-order-line";
import AppConsts from "@/lib/appconst";
import ProductForSelect from "@/store/entities/products/product-for-select";
import _ from "lodash";
Vue.use(require("vue-moment"));
class PageTransferOrderLineRequest extends PageRequest {
  sku: string;
}
@Component
export default class CreateTransferOrder extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  pagerequest: PageTransferOrderLineRequest = new PageTransferOrderLineRequest();
  transferOrder: CreateTransferOrderDto = new CreateTransferOrderDto();
  transferOrderLines: Array<CreateTransferOrderLineDto> = new Array<
    CreateTransferOrderLineDto
  >();
  transferOrderLinesPerPage: Array<CreateTransferOrderLineDto> = new Array<
    CreateTransferOrderLineDto
  >();
  filterTotalCount: number = 0;
  sku: string = "";
  qty: number = 1;
  spinShow: boolean = false;
  objectLoading: boolean = false;
  productName: string = "";
  products: Array<ProductForSelect> = new Array<ProductForSelect>();
  productTypes = [];
  searchProduct_OnPress = _.debounce(
    this.searchProductForSelect,
    AppConsts.debounceDelayTime,
    {
      leading: false,
      trailing: true,
    }
  );
  clients = [];
  warehouses = [];
  conditionTypes = [];
  assetTypes = [];
  isClient() {
    return this.$store.state.session.client != null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.client.clientsForSelect;
        this.clients = re;
      });
  }
  async getWarehouses() {
    await this.$store
      .dispatch({
        type: "warehouse/getListForSelect",
      })
      .then(() => {
        var re = this.$store.state.warehouse.warehousesForSelect;
        this.warehouses = re;
      });
  }
  async getConditionTypes() {
    await this.$store
      .dispatch({
        type: "masterData/getFeatureConditionTypes",
        data: { featureCode: AppConsts.featureConditionType.TO_Create },
      })
      .then(() => {
        var re = this.$store.state.masterData.conditionTypes;
        this.$set(
          this.transferOrder,
          "conditionTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.conditionTypes = re;
      });
  }
  async getAssetTypes() {
    await this.$store
      .dispatch({
        type: "client/getClientAssetTypeServices",
        data: this.transferOrder.clientCode,
      })
      .then(() => {
        var re = this.$store.state.client.clientAssetTypes;
        this.$set(
          this.transferOrder,
          "assetTypeCode",
          re.length === 0 ? "" : re[0].id
        );
        this.assetTypes = re;
        this.resetList();
      });
  }
  cancel() {
    this.reset();
    this.$emit("input", false);
    this.$root.$router.push({ name: "transferorder" });
  }
  async changeClientCode() {
    await this.getAssetTypes();
  }
  changeSrcWarehouseCode() {
    if (
      !Util.isNull(this.transferOrder.dstWarehouseCode) &&
      !Util.isEmpty(this.transferOrder.dstWarehouseCode)
    ) {
      if (
        this.transferOrder.srcWarehouseCode ===
        this.transferOrder.dstWarehouseCode
      ) {
        Util.showErrorMsg(this, "Error.SrcWarehouseMustDiffDst");
        this.transferOrder.srcWarehouseCode = null;
      }
    }
    this.resetList();
  }
  changeDstWarehouseCode() {
    if (
      !Util.isNull(this.transferOrder.srcWarehouseCode) &&
      !Util.isEmpty(this.transferOrder.srcWarehouseCode)
    ) {
      if (
        this.transferOrder.dstWarehouseCode ===
        this.transferOrder.srcWarehouseCode
      ) {
        Util.showErrorMsg(this, "Error.SrcWarehouseMustDiffDst");
        this.transferOrder.dstWarehouseCode = null;
      }
    }
  }
  async searchProductForSelect(keyword) {
    if (
      Util.isEmpty(keyword) ||
      keyword.length < AppConsts.keyWordAtleastLength
    )
      return;
    this.objectLoading = true;
    this.products = await this.$store.dispatch({
      type: "product/searchProductForSelect",
      data: {
        clientCode: this.transferOrder.clientCode,
        keyWord: keyword,
        productType: AppConsts.productTypes.goods,
      },
    });
    this.objectLoading = false;
  }
  changeProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      this.productName = "";
      return;
    }
    var product = _.find(this.products, ["sku", this.sku]);
    if (Util.isNull(product)) {
      this.productName = "";
      Util.showErrorMsg(this, "Error.ProductNotExist");
      return;
    }
    this.productName = product.name;
  }
  async checkProduct() {
    if (Util.isNull(this.sku) || Util.isEmpty(this.sku)) {
      Util.showErrorMsg(this, "Error.SkuRequired");
      return;
    }

    var items = this.transferOrderLines;
    var existedItems = items.filter((item) => item.sku === this.sku);
    if (existedItems.length > 0) {
      Util.showErrorMsg(this, "Error.SkuExisted");
      return;
    } else {
      this.spinShow = true;
      await this.$store
        .dispatch({
          type: "product/checkClientProductInvBalBySku",
          data: {
            sku: this.sku,
            qty: this.qty,
            clientCode: this.transferOrder.clientCode,
            warehouseCode: this.transferOrder.srcWarehouseCode,
            assetTypeCode: this.transferOrder.assetTypeCode,
            conditionTypeCode: this.transferOrder.conditionTypeCode,
          },
        })
        .then((product) => {
          if (!Util.isNull(product)) {
            var newLine = new CreateTransferOrderLineDto();
            newLine = {
              orderNo: 0,
              sku: product.sku,
              productName: product.name,
              productId: product.id,
              orderQty: this.qty,
            };
            this.transferOrderLines.push(newLine);
            this.pageTransferOrderLinesChange();
            this.sku = "";
            this.qty = 1;
          }
        })
        .finally(() => {
          this.spinShow = false;
        });
    }
  }
  async checkProductInvBal(row: any, index: number) {
    this.spinShow = true;
    var item = this.transferOrderLinesPerPage[index];
    var newValue = row.orderQty;
    await this.$store
      .dispatch({
        type: "product/checkClientProductInvBal",
        data: {
          sku: item.sku,
          productId: item.productId,
          qty: newValue,
          clientCode: this.transferOrder.clientCode,
          warehouseCode: this.transferOrder.srcWarehouseCode,
          assetTypeCode: this.transferOrder.assetTypeCode,
          conditionTypeCode: this.transferOrder.conditionTypeCode,
        },
      })
      .then((isEnough) => {
        if (Util.isNull(isEnough) || !isEnough) {
          newValue = item.orderQty;
        }
        this.transferOrderLinesPerPage[index].orderQty = newValue;
        var line = this.transferOrderLines.find(
          (i) => i.productId === item.productId
        );
        line.orderQty = newValue;
        row.orderQty = newValue;
      })
      .finally(() => {
        this.spinShow = false;
      });
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.CreateTransferOrder"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        var lines = this.transferOrderLines.map((item) => {
          return {
            productId: item.productId,
            orderQty: item.orderQty,
            sku: item.sku,
          };
        });
        this.transferOrder.items = lines;
        await this.$store
          .dispatch({
            type: "transferOrder/create",
            data: this.transferOrder,
          })
          .then((result) => {
            Util.showSuccessMsg(this, "Success.CreateTransferOrder");
            this.reset();
            this.$root.$router.push({ name: "transferorder" });
          })
          .finally(() => {
            this.spinShow = false;
          });
      },
    });
  }
  remove(index: number) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L(`Confirm.RemoveTransferOrderProduct`),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        try {
          this.spinShow = true;
          var item = this.transferOrderLinesPerPage[index];
          var items = this.transferOrderLines.filter(
            (i) => i.productId != item.productId
          );
          this.transferOrderLines = items;
          await this.getpage();
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  reset() {
    this.pagerequest = new PageTransferOrderLineRequest();
    this.sku = "";
    this.qty = null;
    this.transferOrder = new CreateTransferOrderDto();
    this.transferOrderLines = new Array<CreateTransferOrderLineDto>();
    this.transferOrderLinesPerPage = new Array<CreateTransferOrderLineDto>();
    this.filterTotalCount = 0;
    this.productName = "";
    this.products = new Array<ProductForSelect>();
    this.objectLoading = false;
  }
  resetList() {
    if (this.transferOrderLines.length > 0) {
      this.$Modal.confirm({
        title: this.L("Tips"),
        content: this.L(`Confirm.ResetTransferOrderDetails`),
        okText: this.L("Yes"),
        cancelText: this.L("No"),
        onOk: async () => {
          this.transferOrderLines = new Array<CreateTransferOrderLine>();
          await this.getpage();
        },
      });
    }
  }
  // sale order line
  get list() {
    var re = this.transferOrderLinesPerPage;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  get loading() {
    return this.$store.state.transferOrder.loading;
  }
  pageChange(page: number) {
    this.$store.commit("transferOrder/setCurrentPage", page);
    this.getpage();
  }

  pagesizeChange(pagesize: number) {
    this.$store.commit("transferOrder/setPageSize", pagesize);
    this.getpage();
  }

  getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    //filters
    this.pageTransferOrderLinesChange();
  }
  pageTransferOrderLinesChange() {
    var items = this.transferOrderLines;
    if (
      !Util.isNull(this.pagerequest.sku) &&
      !Util.isEmpty(this.pagerequest.sku)
    ) {
      items = items.filter(
        (item) => item.sku.indexOf(this.pagerequest.sku) >= 0
      );
    }
    this.filterTotalCount = items.length;
    this.transferOrderLinesPerPage = Util.pagingItems(
      items,
      this.pageSize,
      this.currentPage
    );
  }
  get pageSize() {
    return this.$store.state.transferOrder.pageSize;
  }
  get totalCount() {
    return this.filterTotalCount;
  }
  get currentPage() {
    return this.$store.state.transferOrder.currentPage;
  }

  async getProductTypes() {
    await this.$store
      .dispatch({
        type: "purchaseOrder/getListTypeForSelect",
        data: {
          tableName: AppConsts.tableRef.tablePo.name,
          columnName: AppConsts.tableRef.tablePo.column.productType,
          prefix: AppConsts.tableRef.tablePo.prefix.productType,
          hasAllItem: false,
        },
      })
      .then((re) => {
        this.productTypes = re;
        this.transferOrder.productType =
          Util.isNull(this.productTypes) || this.productTypes.length === 0
            ? ""
            : this.productTypes[0].code;
      });
  }

  async created() {
    await this.getClients();
    await this.getWarehouses();
    await this.getConditionTypes();
    await this.getProductTypes();
    if (this.isClient()) {
      this.transferOrder.clientCode = this.$store.state.session.client.code;
    }
    this.changeClientCode();
  }
  columns = columns;
  transferOrderRule = {
    dstWarehouseCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("DstWarehouse")
        ),
        trigger: "blur",
      },
    ],
    srcWarehouseCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("SrcWarehouse")
        ),
        trigger: "blur",
      },
    ],
    productType: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("productType")
        ),
        trigger: "blur",
      },
    ],
    clientCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("Client")),
        trigger: "blur",
      },
    ],
    assetTypeCode: [
      {
        required: true,
        message: this.L("Error.RequiredField", undefined, this.L("AssetType")),
        trigger: "blur",
      },
    ],
    conditionTypeCode: [
      {
        required: true,
        message: this.L(
          "Error.RequiredField",
          undefined,
          this.L("ConditionType")
        ),
        trigger: "blur",
      },
    ],
  };
}
